import React from 'react'

const SkeletonProductCard = () => {
	return (
		<React.Fragment>
			<div className='absolute w-[194px] md:w-[262px] skeleton-bg z-20'>
				<div className='w-full h-[280px] md:h-[390px] bg-[#F6F6F6]'>
					<div className='p-3 flex justify-between'>
						<div className='bg-[#EFEFEF] w-10 h-5 rounded-sm' />
						<div className='bg-[#EFEFEF] w-8 h-8 rounded-full' />
					</div>
				</div>
				<div className='w-full h-11 bg-[#F6F6F6] mt-1' />
				<div className='w-full h-7 bg-[#F6F6F6] mt-3' />
			</div>
		</React.Fragment>
	)
}

export default SkeletonProductCard